import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'elements';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import styles from './shareLink.scss';

const ShareLink = ({ shareLink, onCopyClick, copied }) => (
  <div className={styles.shareContainer}>
    <div className={styles.linkText}>
      {shareLink}
    </div>
    <CopyToClipboard text={shareLink}>
      <Button
        className={styles.copyBtn}
        size="Small"
        onClick={onCopyClick}
        primary={!copied}
        success={copied}
      >
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </CopyToClipboard>
  </div>
);

ShareLink.propTypes = {
  shareLink: PropTypes.string.isRequired,
  onCopyClick: PropTypes.func.isRequired,
  copied: PropTypes.bool.isRequired,
};

export { ShareLink };



// WEBPACK FOOTER //
// ./src/elements/shareLink/shareLink.js